import { ApiResponse, PaginatedResponse } from '@/domain'
import {
  Account,
  AccountFilters,
  CashBoxBalance,
  EditAccountValues,
  Movement,
  MovementChartData,
  MovementFilters
} from '@/domain/accounts/account'
import { MovementRequest } from '@/domain/accounts/expenses'
import { PaymentMethod } from '@/domain/payments/payments'
import { backendApi } from '../backendApi'

export const accountsApi = {
  getAccounts: (filters?: AccountFilters) =>
    backendApi.get<ApiResponse<PaginatedResponse<Account>>>(
      '/api/v1/accounts',
      { params: filters }
    ).then((res) => res.data.data),

  getAccount: (id: string) =>
    backendApi.get<ApiResponse<Account>>(`/api/v1/accounts/${id}`).then((res) => res.data.data),

  updateAccount: (id: string, data: EditAccountValues) =>
    backendApi.put<ApiResponse<Account>>(`/api/v1/accounts/${id}`, data).then((res) => res.data.data),

  getMovements: (accountId: string, filters?: MovementFilters) =>
    backendApi.get<ApiResponse<PaginatedResponse<Movement>>>(`/api/v1/accounts/${accountId}/movements`, { params: filters }).then((res) => res.data.data),

  exportMovements: (accountId: string, filters?: MovementFilters) =>
    backendApi.get<string>(`/api/v1/accounts/${accountId}/movements/export`, { params: filters }).then((res) => res.data),

  addMovement: (accountId: string, data: MovementRequest) =>
    backendApi.post<ApiResponse<any>>(`/api/v1/orch/accounts/${accountId}/movements`, data).then((res) => res.data.data),

  deleteMovement: (accountId: string, movementId: string) =>
    backendApi.delete<ApiResponse<any>>(`/api/v1/accounts/${accountId}/movements/${movementId}`).then((res) => res.data.data),

  getMovementCounts: (accountId: string, filters?: MovementFilters) =>
    backendApi.get<ApiResponse<{ totalDebits: number; totalCredits: number; balance: number }>>(`/api/v1/accounts/${accountId}/movements-counts`, { params: filters }).then((res) => res.data.data),

  getCashBoxMovements: (userId: string, filters?: { fromDate?: string; toDate?: string; includeCollectors?: boolean; paymentMethod?: PaymentMethod }) =>
    backendApi.get<ApiResponse<CashBoxBalance>>(`/api/v1/accounts/cashbox/${userId}/movements`, { params: filters }).then((res) => res.data.data),

  getMovementChart: (accountId: string, filters?: MovementFilters) =>
    backendApi.get<ApiResponse<MovementChartData[]>>(`/api/v1/accounts/${accountId}/movements/chart`, { params: filters }).then((res) => res.data.data),
}
